import { formatDate } from 'CorePackage/MainModule/common/formatDate';

import { IEpguNotification } from '../../../ApiPackage/SearchModule/interfaces/IEpguNotification';
import styles from './styles.module.scss';
import { KnmSubtitle } from './KnmSubtitle';
import { DATE_FORMAT_LONG } from '../../../CorePackage/MainModule/constants/dateFormat';

interface IEpguNotificationsProps {
  epguNotifications: IEpguNotification[] | undefined;
}

export const EpguNotifications = ({ epguNotifications }: IEpguNotificationsProps) => {
  const epguNotificationsGuids =
    epguNotifications
      ?.filter(item => !!item.subjectGuid)
      .map(item => item.subjectGuid)
      .filter((item, index, values) => values.indexOf(item) === index) || [];

  if (epguNotificationsGuids.length === 0) {
    return null;
  }

  return (
    <KnmSubtitle title="Сведения об информировании контролируемого лица в ЕПГУ">
      {epguNotificationsGuids.map((subjectGuid, guidIndex) => (
        <div key={guidIndex}>
          <div className={styles.SectionTitle}>Контролируемое лицо #{guidIndex + 1}</div>
          {epguNotifications
            ?.filter(item => item.subjectGuid === subjectGuid)
            .map((item, index) => (
              <div key={index}>
                <div className={styles.SectionTitle}>Уведомление #{index + 1}</div>
                {item.eventName && (
                  <div className={styles.Row}>
                    <div className={styles.ColText}>Событие</div>
                    <div className={styles.ColValue}>{item.eventName}</div>
                  </div>
                )}
                {item.epguSendDate && (
                  <div className={styles.Row}>
                    <div className={styles.ColText}>Дата передачи данных в ЕПГУ</div>
                    <div className={styles.ColValue}>
                      {formatDate({ date: item.epguSendDate, dateFormat: DATE_FORMAT_LONG })}
                    </div>
                  </div>
                )}
              </div>
            ))}
        </div>
      ))}
    </KnmSubtitle>
  );
};
